export var CustomGaugeUserConfigModelTypeMappings = {
    startColor: 'colorPicker',
    stopColor: 'colorPicker',
    background: 'colorPicker',
    thickness: 'decimal',
    radius: 'decimal',
    angle: 'decimal',
    pointerLength: 'decimal',
    pointerStroke: 'decimal',
    pointerColor: 'colorPicker'
};
var CustomGaugeConfig = /** @class */ (function () {
    function CustomGaugeConfig(gaugeUserConfigModel) {
        this.gaugeUserConfigModel = {};
        this.gaugeConfigModel = {};
        this.gaugeUserConfigModel = CustomGaugeConfig.setUserConfigModelDefaults(gaugeUserConfigModel);
        this.gaugeConfigModel = CustomGaugeConfig.setConfigModelDefaults(this.gaugeConfigModel);
    }
    CustomGaugeConfig.setUserConfigModelDefaults = function (gaugeUserConfigModel) {
        if (gaugeUserConfigModel === undefined || gaugeUserConfigModel === null) {
            gaugeUserConfigModel = {};
        }
        gaugeUserConfigModel = {
            startColor: gaugeUserConfigModel.startColor || '6fadcf',
            stopColor: gaugeUserConfigModel.stopColor || '8fc0da',
            background: gaugeUserConfigModel.background || 'e0e0e0',
            thickness: gaugeUserConfigModel.thickness || 0.5,
            radius: gaugeUserConfigModel.radius || 1,
            angle: gaugeUserConfigModel.angle || 0.15,
            pointerLength: gaugeUserConfigModel.pointerLength || 0.6,
            pointerStroke: gaugeUserConfigModel.pointerStroke || 0.1,
            pointerColor: gaugeUserConfigModel.pointerColor || '000000'
        };
        gaugeUserConfigModel = this.addHash(gaugeUserConfigModel);
        return gaugeUserConfigModel;
    };
    CustomGaugeConfig.addHash = function (gaugeUserConfigModel) {
        Object.keys(gaugeUserConfigModel).forEach(function (key) {
            if (gaugeUserConfigModel[key] &&
                CustomGaugeUserConfigModelTypeMappings[key] === 'colorPicker' &&
                !gaugeUserConfigModel[key].startsWith('#')) {
                gaugeUserConfigModel[key] = "#".concat(gaugeUserConfigModel[key]);
            }
        });
        return gaugeUserConfigModel;
    };
    CustomGaugeConfig.removeHash = function (gaugeUserConfigModel) {
        Object.keys(gaugeUserConfigModel).forEach(function (key) {
            if (gaugeUserConfigModel[key] &&
                CustomGaugeUserConfigModelTypeMappings[key] === 'colorPicker' &&
                gaugeUserConfigModel[key].startsWith('#')) {
                gaugeUserConfigModel[key] = gaugeUserConfigModel[key].substring(1);
            }
        });
        return gaugeUserConfigModel;
    };
    CustomGaugeConfig.setConfigModelDefaults = function (gaugeConfigModel) {
        if (gaugeConfigModel === undefined || gaugeConfigModel === null) {
            gaugeConfigModel = {};
        }
        return {
            minimum: 0,
            maximum: 100,
            value: 0,
            type: 'gauge',
            height: '250px',
            width: '500px',
            speed: 32
        };
    };
    return CustomGaugeConfig;
}());
export { CustomGaugeConfig };
